import { useEffect, useRef } from 'react';
import { useParams, useMatch } from 'react-router-dom';

const slug = document.querySelector('#root').getAttribute('data-slug');

const useInitRoute = (data, setStoryData, goToStep) => {
  const params = useParams();
  const glossaryMatch = useMatch(`/interactives/${slug}/app/glossary`);
  const isGlossary = !!glossaryMatch;
  // Only run initial routing once. After data loads and the first route is
  // resolved, subsequent URL/param changes are handled by individual components
  // (Slide.js, Header.js) — not by re-running this init logic.
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (!data || hasInitialized.current) return;
    hasInitialized.current = true;

    if (isGlossary) {
      goToStep('glossary');
      return;
    }

    if (params.person) {
      const selectedData = data.stories.data.find(
        (personData) => params.person === personData.name_id,
      );

      if (selectedData) {
        setStoryData(selectedData);
        goToStep('slides');
      } else {
        goToStep('intro');
      }
      return;
    }

    const isBasePath = window.location.pathname.endsWith('/app') ||
      window.location.pathname.endsWith('/app/');

    if (isBasePath) {
      goToStep('intro');
    }

  }, [data, params.person, isGlossary, setStoryData, goToStep]);
};

export default useInitRoute;